var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('file-pond',{ref:"pond",attrs:{"name":"test","files":_vm.files,"server":_vm.server,"allow-multiple":_vm.allowMultiple,"label-idle":_vm.label,"accepted-file-types":['image/png', 'image/jpeg']},on:{"init":_vm.handleFilePondInit,"addfile":_vm.handleProcessFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }